export const scrollToElement = (element, align) => {
  element.scrollIntoView({ behavior: 'smooth', block: align || "start", }); // Top
}